export const INSTAGRAM_BOOKINGS_ENTRY_SOURCE_KEY = 'entry_source'

export const INSTAGRAM_BOOKINGS_ENTRY_POINTS = {
  IN_APP_NOTIFICATION: 'target_type',
  DEEPLINK: 'deeplink',
  ONLINE_BOOKING: 'online_booking',
}

export const ONLINE_BOOKING_ENTRY_SOURCES = {
  MARKETING: 'marketing',
  SETTINGS: 'settings',
  DEEPLINK: 'deeplink',
  TARGET_TYPE: 'target_type',
  CALENDAR: 'calendar',
  PROFILE_PREVIEW: 'profile_preview',
  IMPORT_CLIENTS: 'import_clients',
}

export const ONLINE_BOOKING_ENTRY_SOURCE_QUERY_KEY = 'entry_source'
